import BaseForm from '../base';
export class PortalPanelForm extends BaseForm {
    constructor(...args) {
        super(...args);
    }
}
export default {
    components: [
        {
            label: 'URL',
            key: 'url',
            type: 'textfield',
            placeholder: 'https://your.epicio.com/some/path',
            description: 'Web page or dashboard to embed in this panel. Must use HTTPS. ' +
                'Common sources: your Epicio sites (*.epicio.com, *.epicio.net) and ' +
                'Acoem Cadence (cadence.acoem.com).',
            // Form-level guard so the editor sees an inline error instead of a runtime
            // "not allowed by security policy" growl. SCE (resourceUrlWhitelist) is
            // still the authoritative trust boundary at load time.
            validate: {
                // Requires the entire value to match: `https://` followed by at least
                // one non-slash, non-whitespace char so a host is genuinely present.
                // End anchor ensures trailing whitespace/garbage is rejected at edit
                // time, matching the custom message below. (`https:///`, `https:// foo`,
                // and `https://example.com ` all fail.)
                pattern: '^https://[^/\\s]\\S*$',
                customMessage: 'URL must start with https:// and include a host.',
            },
        },
        {
            label: 'Path',
            key: 'path',
            type: 'textfield',
            description: 'Path appended to the URL (e.g. /public/dashboards/{id}).',
        },
        {
            label: 'Do not add cache buster',
            key: 'disableCacheBuster',
            type: 'checkbox',
            defaultValue: false,
            // Some embedded web servers (e.g. ControlByWeb relay boards) only serve
            // their root page for a bare "/" and 404 when a query string is present.
            // The default "?_ts=" cache buster breaks those targets, so allow it to
            // be turned off per portal.
            description: 'By default a unique "?_ts=" query parameter is appended on each ' +
                'load to bypass browser caching. Enable this for targets whose web server ' +
                'cannot serve its page with a query string (e.g. some embedded relay devices ' +
                'return a 404).',
        },
    ]
};
